import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PATINPerfis.css";

const API = "/api/patin/auth";

export default function PATINMeuPlano() {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState(null);
  const [plano, setPlano] = useState(null);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;

    async function carregar() {
      try {
        const respostaUsuario = await fetch(`${API}/me`, {
          credentials: "same-origin"
        });

        if (respostaUsuario.status === 401) {
          navigate("/patin/login", { replace: true });
          return;
        }

        if (!respostaUsuario.ok) {
          throw new Error("Não foi possível verificar sua sessão.");
        }

        const dadosUsuario = await respostaUsuario.json();

        if (dadosUsuario.perfil !== "empreendedora") {
          navigate("/patin/mentora", { replace: true });
          return;
        }

        const resposta = await fetch(`${API}/meu-patin`, {
          credentials: "same-origin"
        });

        if (!resposta.ok) {
          throw new Error("Não foi possível carregar seu PATIN.");
        }

        const dados = await resposta.json();

        if (ativo) {
          setUsuario(dadosUsuario);
          setPlano(dados);
        }
      } catch (error) {
        if (ativo) setErro(error.message);
      } finally {
        if (ativo) setCarregando(false);
      }
    }

    carregar();

    return () => {
      ativo = false;
    };
  }, [navigate]);

  async function sair() {
    await fetch(`${API}/logout`, {
      method: "POST",
      credentials: "same-origin"
    });

    navigate("/patin/login", { replace: true });
  }

  if (carregando) {
    return <main className="patin-perfis">Carregando...</main>;
  }

  return (
    <main className="patin-perfis">
      <section className="patin-painel">
        <header className="patin-painel-header">
          <div>
            <div className="patin-etiqueta">MEU PATIN</div>
            <h1>Olá, {usuario?.nome || "Empreendedora"}!</h1>
            <p>Seu espaço de transformação e crescimento.</p>
          </div>

          <button className="patin-sair" onClick={sair}>
            Sair
          </button>
        </header>

        {erro ? (
          <div className="patin-erro" role="alert">{erro}</div>
        ) : plano ? (
          <>
            <div className="patin-indicador">
              <span>Meu negócio</span>
              <strong className="patin-negocio">
                {plano.nome_negocio || "Não informado"}
              </strong>
            </div>

            <article className="patin-participante">
              <div>
                <h2>Meu Plano de Transformação</h2>
                <p>Participante: {plano.nome}</p>
                <p>Protocolo: {plano.protocolo}</p>
                <p>Status: {plano.status}</p>
              </div>
            </article>

            <p className="patin-aviso">
              Seu perfil está ativo. O formulário com salvamento
              compartilhado será disponibilizado na próxima etapa.
            </p>
          </>
        ) : (
          <p>Nenhum PATIN vinculado à sua conta.</p>
        )}
      </section>
    </main>
  );
}
